import React from 'react';
import Image from 'next/future/image';

import Separator from 'components/Separator';
import ZpButton from 'components/zpButton';
import { importStatic, openInCurrentTab } from 'utils';

const ZippiaCompanyBadge = () => {
  return (
    <section className="section">
      <div className="container d-flex justify-content-md-between flex-column flex-md-row  z-pb-88">
        <div className="text-md-left text-center">
          <h2 className="brandonH2 z-mb-24">2024 Best Companies To Work For</h2>
          <p className="z-mb-24 z-mt-0 openSansNormal">Is Your Company A Great Place To Work?</p>
          <ZpButton
            theme="super-primary"
            className="z-mb-24 z-mt-0"
            staticWidth={300}
            onClick={() => {
              openInCurrentTab('/employer/best-companies/#homepage');
            }}
            size="big"
          >
            Add Your Company To The List
          </ZpButton>
        </div>
        <div className="text-md-right text-center">
          <Image
            src={importStatic('/ui-router/images/zippia2024Badge.webp')}
            width={212}
            height={230}
            alt={'Zippia Badge 2024'}
          />
        </div>
      </div>
      <Separator noSpacing />
    </section>
  );
};
export default ZippiaCompanyBadge;
